import { ChangeDetectionStrategy, Component, input, model, inject } from '@angular/core';
import { SearchResultRenderer, SOFT_SHELL_SEARCH_DISMISS } from '@softapps/core';
import { Ticket } from '../../data/ticket.model';
import { IconComponent, TranslatePipe } from '@softline/ui-core';
import { Router, ActivatedRoute } from '@angular/router';
import { TicketQueryService } from '../../services/ticket-query.service';

@Component({
  selector: 'soft-ticket-search-result',
  imports: [IconComponent, TranslatePipe],
  templateUrl: './ticket-search-result.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TicketSearchResult extends SearchResultRenderer<Ticket> {
  readonly router = inject(Router);
  readonly route = inject(ActivatedRoute);
  readonly ticketQueryService = inject(TicketQueryService);
  readonly dismissSearchOverlay = inject(SOFT_SHELL_SEARCH_DISMISS);

  override result = input.required<Ticket>();
  override highlighted = input(false);
  override disabled = model(false);

  async openTicket(id: number): Promise<void> {
    if (!id) {
      return;
    }

    await this.router.navigate(['/ticket', id], {
      queryParams: this.route.snapshot.queryParams,
    });
    await this.dismissSearchOverlay();
  }
}
